
import { useParams } from "react-router-dom";
import { DisenioLoteDistribuido } from "../../layout";
import { Button, Grid, TextField } from "@mui/material";
import { FormCantidadAndDestares, FormInformacionUser, TituloAndButtonAdd, TituloNormalScren, TablaTotalesPlanilla, FormInfoCargueros } from "../../components";
import { usePlanillassStore } from "../../../store";
import { startSavingPlanilla } from "../../../services";

import Swal from "sweetalert2";




export const CrearPlanilla = () => {


    const { id } = useParams();
    const { resetForm, items, formValues, updateFormValue, addItem } = usePlanillassStore();
    const {fecha, vehiculo, conductor, cliente, pesador, horaInicio, horaFinal, descuento, 
            cantidad, valorKilo, cargueros, acuerdo, valorAcordado, observacion } = formValues;

    const handleChanges = ({ target }) => {
        updateFormValue({ name: target.name, value: target.value });
    }




    const hancleCrearPlanilla = async(e) => {
        e.preventDefault();
        const unidades = items.reduce( (t, i) => Number(t) + (Number(i.huacales) * Number(i.avesXhuacal)), 0);

        if( Number(cantidad) !== unidades ){
            return Swal.fire('Error', 'La suma no coincide con el total de pollos', 'error');
        }

        if([fecha, vehiculo, conductor, cliente, pesador, horaInicio, horaFinal, descuento, cantidad, 
            valorKilo, acuerdo, valorAcordado].includes('') ){
            return Swal.fire('Error', 'Verificar el formulario hay datos pendientes', 'error');
        }

        if(cargueros.length < 1){
            return Swal.fire('Error', 'Seleccione al menos un carguero.', 'error');
        }

        await Swal.fire({
            title: `Crear Planilla`,
            text: `¿Deseas crear esta planilla?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        }).then(async( result ) => {
            if(result.value){
                const resp = await startSavingPlanilla({ ...formValues, items, id });
                if( resp ){
                    resetForm();
                }
            }
        });
    }


    return (
        <DisenioLoteDistribuido titulo={`Crear Planilla`}>
            <form onSubmit={ hancleCrearPlanilla } >
                <Grid container rowSpacing={2.5} columnSpacing={2}>

                    {/* FORMULARIO INFORMACION DE USUARIOS Y TIEMPOS */}
                    <TituloNormalScren titulo="Control de Turno" tamanio='20' centro={false} bottom={-1} />
                    <FormInformacionUser onCahnge={ handleChanges } />

                    {/* TABLA TOTALES DE PLANILLA AL LLENAR */}
                    {(items.length > 0) &&
                    <TablaTotalesPlanilla items={items} onCahnge={handleChanges} formValues={formValues} />
                    }

                    {/* FORMULARIO INFORMACION DE CANTIDADES Y DESTARES */}
                    <TituloAndButtonAdd titulo="Control de Cantidades" 
                        tamanio='20' top={2}
                        centro={false} bottom={-1} 
                        titulo2="Agregar" 
                        onFunction={ addItem }
                    />
                    {/* <FormCantidadAndDestares onCahnge={handleChanges} formValues={formValues} items={items} setItems={setItems} /> */}
                    <FormCantidadAndDestares onCahnge={handleChanges} />


                    {/* FORMULARIO INFORMACION DE OBSERVACION */}
                    <TituloNormalScren titulo="Observación" tamanio='20' centro={false} bottom={-1.3} />
                    <Grid item xs={12}>
                        <TextField fullWidth multiline rows={3}
                            label="Observación" name="observacion" value={observacion}
                            onChange={handleChanges} placeholder="Observaciones de planilla"
                        />
                    </Grid>

                    
                    {/* FORMULARIO INFORMACION DE CARGUEROS Y PRECIOS ACORDADOS */}
                    <TituloNormalScren titulo="Información de Cargueros" tamanio='20' centro={false} bottom={-1} top={2} />
                    <FormInfoCargueros onCahnge={handleChanges} />
                </Grid>
    
                <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                    <Grid item xs={ 12 } sm={ 8 } >
                        <Button variant='contained' fullWidth type='submit'>
                            Crear Planilla
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </DisenioLoteDistribuido>
    )
}
